import { ReactElement, useEffect, useState } from 'react'
import useScript from '../../Hooks/useScript'
import { ReepayProps } from './props'

const Reepay = ({
    isOpen,
    onAccept,
    onCancel,
    onClose,
    token,
}: ReepayProps): ReactElement => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [reepayModal, setReepayModal] = useState<any>(null)
    const status = useScript('https://checkout.reepay.com/checkout.js')

    useEffect(() => {
        if (status === 'ready') {
            setReepayModal(new window.Reepay.ModalCheckout())
        }

        return () => {
            if (status === 'ready' && reepayModal) {
                reepayModal.destroy()
                setReepayModal(null)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status])

    useEffect(() => {
        if (reepayModal && isOpen && token) {
            reepayModal.show(token)

            reepayModal.addEventHandler(window.Reepay.Event.Accept, () => {
                if (onAccept) onAccept()
            })
            reepayModal.addEventHandler(window.Reepay.Event.Cancel, () => {
                if (onCancel) onCancel()
            })
            reepayModal.addEventHandler(window.Reepay.Event.Close, () => {
                if (onClose) onClose()
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen])

    return <></>
}

export default Reepay
